export default __webpack_public_path__ + "img/ca55f8c468ed882b908c4a962c810345.svg";